'use client'

import { memo } from 'react'

import { SeoListName } from 'shared/analytics'
import OfflineNotificationLayer from 'shared/ui/Offline'

import { CartPorts } from '../ports'
import CartItemsList from '../submodules/items/components/CartItemsList'
import CartSummary from '../submodules/summary/components/CartSummary'
import { CartItem } from '../types'

import styles from './CartDrawerWebContent.module.scss'

const MODAL_BASKET_LIST_NAME = SeoListName.MODAL_BASKET_LIST_NAME

const CartDrawerWebContent = memo(
  ({
    productsList,
    asPath,
    isCartEditMode,
    isOnline,
    handleModalClose,
    ports
  }: {
    productsList: CartItem[]
    asPath: string
    isCartEditMode?: boolean
    isOnline: boolean
    handleModalClose: () => void
    ports: CartPorts
  }) => (
    <div className={styles.webContent}>
      <div
        className={styles.webCartDrawerContent}
        id='cart-drawer-content-desktop'
      >
        <div className={styles.cartDrawerProductsList}>
          <CartItemsList
            items={productsList}
            seoButtonPlace={asPath}
            isModal
            isCartEditMode={isCartEditMode}
            listName={MODAL_BASKET_LIST_NAME}
            ports={ports}
          />
          {!isOnline && <OfflineNotificationLayer />}
        </div>
        <div className={styles.summaryWrapper}>
          <CartSummary
            isCartDrawer
            handleModalClose={handleModalClose}
            destination='cart'
            ports={ports}
          />
        </div>
      </div>
    </div>
  )
)

export default CartDrawerWebContent
